<template>
  <div>
    <!-- 验收 -->
    <PageAllow
      controller="Purchases"
      action="examine"
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <!-- 表格 -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("CRUD.info", [$t("PurchasesDetail.ObjectName")]) }}
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="purchase.status | purchaseStatusColor"
                :text-color="purchase.status | purchaseStatusTextColor"
              >
                {{ purchase.status | purchaseStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <!-- 采购单号 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.purchase_code") }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.purchase_code }}
                </v-card>
              </v-col>
              <!-- 创建时间 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.created") }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.created | formatTime }}
                </v-card>
              </v-col>
              <!-- 希望配送日 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.expect_date") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase.hope_delivery_date | formatDate }}
                  </span>
                </v-card>
              </v-col>
              <!-- 仓库 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.stock")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.stock ? purchase.stock.name : "" }}
                </v-card>
              </v-col>
              <!-- 供应商 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.supplier_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.supplier ? purchase.supplier.supplier_name : "" }}
                </v-card>
              </v-col>
              <!-- 采购单来源 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.origin_flg")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.origin_flg | originFlgsText }}
                </v-card>
              </v-col>
              <!-- 创建者 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.creater")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase.creater_name }}
                  </span>
                </v-card>
              </v-col>
              <!-- 第三方单号 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.purchase")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase.ext_code }}
                  </span>
                </v-card>
              </v-col>
              <!-- 要货单单号 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="text-no-wrap">
                    {{ purchase.purchase_order_code }}
                  </span>
                </v-card>
              </v-col>
              <!-- 收货人 -->
              <v-col
                cols="12"
                md="4"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.receiver_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      purchase.delivery_info
                        ? purchase.delivery_info.receiver_name
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 联系方式 -->
              <v-col
                cols="12"
                md="8"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.receiver_phone")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      purchase.delivery_info
                        ? purchase.delivery_info.receiver_phone
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 收货地址 -->
              <v-col
                cols="12"
                md="12"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.receiver_address")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      purchase.delivery_info
                        ? purchase.delivery_info.receiver_province +
                          purchase.delivery_info.receiver_city +
                          purchase.delivery_info.receiver_area +
                          purchase.delivery_info.receiver_address
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 备注 -->
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase.memo }}
                  </span>
                </v-card>
              </v-col>
              <!-- 附件 -->
              <v-col cols="12" sm="12" md="12">
                <v-card
                  class="pa-2 d-flex overflow-auto text-no-wrap"
                  outlined
                  tile
                >
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.attachments")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <!-- 上传图片集 -->
                  <span class="ml-4">
                    <v-card
                      height="160"
                      width="240"
                      v-if="album && album.length > 0"
                    >
                      <v-carousel
                        hide-delimiters
                        cycle
                        height="160"
                        width="240"
                      >
                        <v-carousel-item
                          v-for="(item, i) in album"
                          :key="i"
                          :src="item"
                          @click.stop="$showFullscreenImages(album, i)"
                        >
                        </v-carousel-item>
                      </v-carousel>
                    </v-card>
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- 活动记录 -->
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.indexOf(1) == -1 ? panels.push(1) : '';
                "
              >
                {{ $t("PurchasesDetail.activities.title") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <!-- 活动记录 -->
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="activities_details"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span>
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-sheet class="transparent-background-color py-4">
        <v-card>
          <v-tabs
            v-model="tabB"
            height="64"
            class="ms-3"
            background-color="transparent"
          >
            <v-tab>
              <v-card-title class="pa-0">
                {{ $t("PurchasesDetail.detailName") }}
              </v-card-title>
            </v-tab>
            <v-tab>
              <v-card-title class="pa-0">
                {{ $t("PurchasesDetail.activities.receipt") }}
              </v-card-title>
            </v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-items v-model="tabB" >
              <v-tab-item>
                <!-- 明细 -->
                <v-card flat>
                  <v-data-table
                      id="details_table"
                      :headers="headers"
                      :items="purchase_details"
                      multi-sort
                      disable-pagination
                      hide-default-footer
                      class="elevation-2 px-4 mt-4 pb-4"
                      style="border-collapse: collapse"
                  >
                    <!-- 操作 -->
                    <template v-slot:header.data-table-expand="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.before_tax_price="{ item }">
                    <span class="text-no-wrap">
                      {{ $t("Global.money") }}{{ item.before_tax_price | formatWithDot(3) }}
                    </span>
                    </template>
                    <template v-slot:item.after_tax_price="{ item }">
                    <span class="text-no-wrap">
                      {{ $t("Global.money") }}
                      {{ item.after_tax_price | formatWithDot(3) }}
                    </span>
                    </template>
                    <!-- 单价 -->
                    <template v-slot:item.price="{ item }">
                    <span v-if="item.negotiate_price_flg == 1">
                      {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
                    </span>
                      <span v-else>
                      <span>
                        {{ $t("Global.money") }}{{ item.price | formatTwoDot }}
                      </span>
                    </span>
                    </template>
                    <!-- 采购订货数 -->
                    <template v-slot:item.quantity="{ item }">
                      {{ item.quantity | formatTwoDot }}{{ item.unit }}
                    </template>
                    <!-- 基准订货数 -->
                    <template v-slot:item.default_quantity="{ item }">
                      {{ item.default_quantity | formatTwoDot }}{{ item.default_unit }}
                    </template>
                    <template v-slot:item.before_tax_total="{ item }">
                      {{ $t("Global.money") }}
                      {{ item.before_tax_total | formatTwoDot }}
                    </template>
                    <template v-slot:item.after_tax_total="{ item }">
                      {{ $t("Global.money") }}
                      {{ item.after_tax_total | formatTwoDot }}
                    </template>
                    <template v-slot:item.total="{ item }">
                    <span v-if="item.negotiate_price_flg == 1">
                      {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
                    </span>
                      <span v-else>
                      <span>
                        {{ $t("Global.money") }}{{ item.total | formatTwoDot }}
                      </span>
                    </span>
                    </template>
                    <template v-slot:item.examine_num="{ item }">
                      {{ item.examine_num | formatTwoDot }}
                    </template>
                    <template v-slot:item.default_examine_num="{ item }">
                      {{ item.default_examine_num | formatTwoDot }}
                    </template>
                    <!-- 生产日期 -->
                    <template v-slot:item.production_date="{ item }">
                    <span>
                      {{ item.production_date | formatDate }}
                    </span>
                    </template>
                    <!-- 过期日期 -->
                    <template v-slot:item.expire_date="{ item }">
                    <span>
                      {{ item.expired_date | formatDate }}
                    </span>
                    </template>
                    <!-- 备注 -->
                    <template v-slot:item.examine_memo="{ item }">
                    <span>
                      {{ item.examine_memo }}
                    </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <!-- 相关入库单据 -->
                <v-card flat>
                  <v-data-table
                    :headers="stockInsHeaders"
                    :items="stockIns_details"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.stock_name>
                      {{ purchase.stock.name }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        small
                        label
                        :color="item.status | stockOrderINStatusColor"
                        :text-color="item.status | stockOrderINStatusTextColor"
                      >
                        {{ item.status | stockOrderINStatusText }}
                      </v-chip>
                    </template>
                    <template v-slot:item.created="{ item }">
                      {{ item.created | formatTime }}
                    </template>
                    <template v-slot:item.finish_time="{ item }">
                      {{ item.finish_time | formatTime }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        dark
                        color="info"
                        class="px-2 me-2 mb-1"
                        :href="'/#/stock-orders-in/' + item.id"
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("PurchasesList.actions.detail") }}
                      </v-btn>
                      <v-btn
                        small
                        dark
                        color="action"
                        class="px-2 me-2 mb-1"
                        @click.stop="$router.push('/stock-orders-in/' + item.id + '/in')"
                      >
                        {{ $t("StockOrderIN.actions.stockIn") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Purchases from "@/api/purchases";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: i18n.t("Nav.purchasesSupplierExamine"),
          disabled: true,
          href: "/purchases-examine",
        },
      ];
      if (this.purchase && this.purchase.purchase_code) {
        items.push({
          text: this.purchase.purchase_code,
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    headers() {
      var headers = [
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.supply_code"),
          align: "start",
          sortable: false,
          value: "supply_code",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.standard_name"),
          align: "start",
          sortable: false,
          value: "standard_name",
        },
      ];
      if (
        this.settings &&
        this.settings.use_tax == 1
      ) {
        headers.push(
          //商品税率
          {
            text: i18n.t("PurchasesDetail.purchaseFields.tax_rate"),
            align: "end",
            sortable: false,
            value: "tax_rate",
          },
          //     单价 不含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.before_tax_price"),
            align: "end",
            sortable: false,
            value: "before_tax_price",
          },
          //   单价 含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.after_tax_price"),
            align: "end",
            sortable: false,
            value: "after_tax_price",
          }
        );
      } else if (
        this.settings &&
        this.settings.use_tax == 0
      ) {
        headers.push(
          //   单价
          {
            text: i18n.t("PurchasesDetail.purchaseFields.price"),
            align: "end",
            sortable: false,
            value: "price",
          }
        );
      }
      headers.push(
        {
          text: i18n.t("PurchasesDetail.purchaseFields.quantity"),
          align: "end",
          sortable: false,
          value: "quantity",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.default_quantity"),
          align: "end",
          sortable: false,
          value: "default_quantity",
        }
      );
      if (
        this.settings &&
        this.settings.use_tax == 1
      ) {
        headers.push(
          //   采购金额 不含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.before_tax_total"),
            align: "end",
            sortable: false,
            value: "before_tax_total",
          },
          //   采购金额 含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.after_tax_total"),
            align: "end",
            sortable: false,
            value: "after_tax_total",
          }
        );
      } else if (
        this.settings &&
        this.settings.use_tax == 0
      ) {
        headers.push(
          // 采购金额
          {
            text: i18n.t("PurchasesDetail.purchaseFields.total"),
            align: "center",
            sortable: false,
            value: "total",
          }
        );
      }
      headers.push(
        {
          text: i18n.t("PurchasesDetail.purchaseFields.stock_in_num"),
          align: "end",
          sortable: false,
          value: "examine_num",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.default_stock_in_num"),
          align: "end",
          sortable: false,
          value: "default_examine_num",
        }
      );
      if (
        this.settings &&
        this.settings.product_date_setting == 1
      ) {
        headers.push(
          {
            text: i18n.t("PurchasesDetail.purchaseFields.production_date"),
            align: "start",
            sortable: false,
            value: "production_date",
          },
          {
            text: i18n.t("PurchasesDetail.purchaseFields.expire_date"),
            align: "start",
            sortable: false,
            value: "expire_date",
          }
        );
      }
      headers.push({
        text: i18n.t("PurchasesDetail.purchaseFields.examine_memo"),
        align: "start",
        sortable: false,
        value: "examine_memo",
      });
      if (
        this.settings &&
        this.settings.qualify_report_enable == 1
      ) {
        headers.push({
          text: i18n.t("PurchasesDetail.purchaseFields.qualify_report"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "qualify_report_img",
        });
      }
      if (
        !this.purchase.delivery_date &&
        this.settings &&
        this.settings.product_date_setting
      ) {
        headers.push({
          text: "",
          align: "start",
          sortable: false,
          value: "data-table-expand",
        });
      }
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("PurchasesDetail.activities.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("PurchasesDetail.activities.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("PurchasesDetail.activities.operater"),
        align: "start",
        sortable: false,
        value: "operater.name",
      },
    ],
    stockInsHeaders: () => [
      {
        text: i18n.t("PurchasesDetail.stockIns.stock_order_code"),
        align: "start",
        sortable: false,
        value: "stock_order_code",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.stock_name"),
        align: "start",
        sortable: false,
        value: "stock_name",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.finish_time"),
        align: "start",
        sortable: false,
        value: "finish_time",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    stocks: {},
    suppliers: {},
    panels: [0],
    tab: null,
    tabB: null,
    purchase: {},
    purchase_details: [],
    activities_details: [],
    stockIns_details: [],
    album: [],
  }),

  mounted() {
    this.getPurchasesDetailsFromAPI()
  },

  methods: {
    getPurchasesDetailsFromAPI() {
      Purchases.fetchExamineDetail(this.$route.params.id, {
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchase = response.data.purchase;
            this.purchase_details = response.data.purchase.purchase_details
            this.activities_details = response.data.order_activities;
            this.stockIns_details = response.data.stock_ins;
            this.album = response.data.purchase.img;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    purchase_details: {
      deep: true,
      handler() {
        var dayjs = require("dayjs");
        this.purchase_details.forEach((detail) => {
          // 供应商发货数据整理
          if (detail.stock_in_details) {
            detail.stock_in_details.forEach((stockDetail) => {
              if (
                this.settings &&
                this.settings.product_date_setting &&
                Number(detail.bestbefore) &&
                stockDetail.production_date &&
                !stockDetail.expired_date
              ) {
                stockDetail.expired_date = dayjs(stockDetail.production_date)
                  .add(Number(detail.bestbefore), "day")
                  .format("YYYY-MM-DD");
              }
            });
          }

          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.bestbefore) &&
            detail.production_date &&
            !detail.expired_date
          ) {
            detail.expired_date = dayjs(detail.production_date)
              .add(Number(detail.bestbefore), "day")
              .format("YYYY-MM-DD");
          }
        });
      },
    },
  },
};
</script>